import { resolveMediaUrl } from './mediaUrl';

const parseRowCaption = (caption) => {
  if (!caption) {
    return {
      title: '',
      description: '',
      linkUrl: '',
      reverse: false,
    };
  }

  try {
    const parsed = JSON.parse(caption);
    return {
      title: parsed.title || '',
      description: parsed.description || '',
      linkUrl: parsed.linkUrl || '',
      reverse: parsed.reverse === true || parsed.reverse === 'true',
    };
  } catch {
    return {
      title: '',
      description: '',
      linkUrl: '',
      reverse: false,
    };
  }
};

export const parseHomeWhatWeDoContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const section = page.sections.find((item) => item.key === 'what-we-do');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const rowMedia = section.media?.groups?.rows || [];

  if (!fields.eyebrow || !fields.title || rowMedia.length === 0) {
    return null;
  }

  const rows = rowMedia
    .map((item) => {
      const parsed = parseRowCaption(item.caption);
      if (!parsed.title || !item.url) {
        return null;
      }

      return {
        title: parsed.title,
        description: parsed.description || '',
        image: resolveMediaUrl(item.url),
        icon: item.thumbnailUrl ? resolveMediaUrl(item.thumbnailUrl) : '',
        to: parsed.linkUrl || '#',
        reverse: parsed.reverse,
      };
    })
    .filter((row) => row && row.icon);

  if (rows.length === 0) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow,
    title: fields.title,
    rows,
  };
};
